var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTspayBannerLandingOmino(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "422px",
    viewBox: "0 0 1440 422",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tspay_banner_landing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9981081%",
    y1: "0.00130331754%",
    x2: "49.9981081%",
    y2: "100.001303%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#213B48",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 1440,
    height: 422
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00275506039%",
    y1: "50.0094624%",
    x2: "99.9921761%",
    y2: "50.0094624%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000505997501%",
    y1: "50.0098376%",
    x2: "99.9899271%",
    y2: "50.0098376%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00222222222%",
    y1: "50.0047222%",
    x2: "100.002222%",
    y2: "50.0047222%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tspay_banner_landing"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    opacity: 0.2807,
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.000000, -49.000000)",
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.6,540.4 C129.3,484.3 147.9,425.2 184.4,382.3 C220.9,339.4 276.3,311.6 332.5,307.9 C390.1,304.1 446.6,323.8 501.2,342.9 C558.9,363.1 618.5,383.9 679.1,376.7 C722.4,371.5 763.2,352.1 802.8,333.4 C849.5,311.3 897.7,288.4 949.5,289.4 C967.1,289.7 984.8,292.9 1002,295.9 C1025.8,300.1 1050.4,304.5 1074.6,301.3 C1110.4,296.5 1145.2,275.1 1172.6,240.9 C1195.9,211.8 1211.3,178.2 1227.3,136.6 C1236.3,113.3 1244.8,88.5 1242.5,63.9 C1240.2,40.4 1224.7,14.2 1199.4,9.4 L1199.6,8.4 C1225.4,13.2 1241.3,39.9 1243.6,63.8 C1246,88.7 1237.4,113.6 1228.4,137 C1212.3,178.7 1196.9,212.4 1173.5,241.5 C1145.9,275.9 1110.9,297.5 1074.8,302.3 C1050.4,305.5 1025.7,301.2 1001.9,296.9 C984.8,293.9 967.1,290.7 949.6,290.4 C898,289.4 849.9,312.2 803.3,334.3 C763.7,353.1 722.8,372.5 679.3,377.7 C670.8,378.7 662.4,379.2 653.9,379.2 C601.8,379.2 550.7,361.3 500.9,343.9 C446.4,324.8 390,305.1 332.6,308.9 C276.6,312.6 221.5,340.3 185.2,383 C148.9,425.7 130.3,484.5 135.6,540.3 L134.6,540.4 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    opacity: 0.5354,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.3,1.1 C94,1.1 1.1,94 1.1,208.1 C1.1,322.3 94.1,415.2 208.3,415.2 C322.5,415.2 415.5,322.3 415.5,208.1 C415.5,94 322.5,1.1 208.3,1.1 M208.3,416.3 C152.6,416.3 100.3,394.7 61,355.4 C21.7,316.1 0,263.8 0,208.2 C0,152.6 21.7,100.3 61,61 C100.3,21.6 152.6,0 208.3,0 C264,0 316.3,21.6 355.6,60.9 C394.9,100.2 416.6,152.5 416.6,208.1 C416.6,263.7 394.9,316 355.6,355.3 C316.3,394.6 263.9,416.3 208.3,416.3",
    id: "Fill-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.3,27 C108.3,27 27,108.3 27,208.1 C27,307.9 108.3,389.2 208.2,389.2 C308.1,389.2 389.5,308 389.5,208.1 C389.5,108.2 308.2,27 208.3,27 M208.3,390.3 C107.7,390.3 26,308.6 26,208.1 C26,107.6 107.7,26 208.3,26 C308.9,26 390.6,107.7 390.6,208.2 C390.6,308.7 308.8,390.3 208.3,390.3",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.3,53 C122.6,53 53,122.6 53,208.1 C53,293.6 122.7,363.3 208.3,363.3 C293.9,363.3 363.6,293.7 363.6,208.1 C363.6,122.5 293.9,53 208.3,53 M208.3,364.4 C122.1,364.4 52,294.3 52,208.2 C52,122.1 122.1,51.9 208.3,51.9 C294.5,51.9 364.6,122 364.6,208.1 C364.6,294.2 294.5,364.4 208.3,364.4",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.3,78.9 C137,78.9 79,136.9 79,208.1 C79,279.4 137,337.3 208.3,337.3 C279.6,337.3 337.6,279.3 337.6,208.1 C337.6,136.9 279.6,78.9 208.3,78.9 M208.3,338.4 C136.4,338.4 77.9,280 77.9,208.1 C77.9,136.3 136.4,77.8 208.3,77.8 C280.2,77.8 338.7,136.2 338.7,208.1 C338.6,280 280.2,338.4 208.3,338.4",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.3,104.9 C151.3,104.9 105,151.2 105,208.2 C105,265.2 151.4,311.5 208.3,311.5 C265.2,311.5 311.6,265.2 311.6,208.2 C311.6,151.2 265.3,104.9 208.3,104.9 M208.3,312.5 C150.7,312.5 103.9,265.7 103.9,208.2 C103.9,150.7 150.7,103.8 208.3,103.8 C265.9,103.8 312.7,150.6 312.7,208.1 C312.7,265.6 265.8,312.5 208.3,312.5",
    id: "Fill-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(301.248379, 207.404582)",
    fill: "url(#linearGradient-4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    points: "1.5 239.9 0 238.4 238.6 0 240.1 1.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy",
    transform: "translate(524.248379, 77.404582)",
    fill: "url(#linearGradient-5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "1.5 239.9 0 238.4 238.6 0 240.1 1.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy-2",
    transform: "translate(606.000000, 263.000000)",
    fill: "url(#linearGradient-6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.9 144 0 143.1 143.1 0 144 0.9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(272.092727, 74.604000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.889781, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(0.109613, 1.766006)",
    fill: "#D4A181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7,8.09149613 C38.8,17.5914961 38.2,41.7914961 31.6,43.4914961 C29,44.1914961 23.3,42.4914961 17.6,39.0914961 L21.2,64.4914961 L0,64.4914961 L7.3,30.4914961 C3.2,25.6914961 0.5,19.8914961 0.9,13.2914961 C2.3,-5.60850387 28.6,-1.50850387 33.7,8.09149613 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.3259769,0.496 C28.2259769,0.996 33.6259769,2.796 35.1259769,3.896 C35.1259769,9.496 34.0259769,11.196 24.7259769,10.996 C22.4259769,12.196 20.7259769,14.296 18.8259769,16.996 C19.6259769,28.296 21.8259769,33.896 25.2259769,33.896 C30.4259769,33.896 34.9259769,30.596 37.1259769,30.596 C38.8259769,30.596 38.4259769,32.696 37.3259769,34.196 C36.4259769,35.496 31.9259769,36.696 31.9259769,38.696 C31.9259769,39.796 32.9259769,39.796 33.8259769,39.796 L34.1259769,39.796 C34.8259769,39.796 35.4259769,39.796 35.4259769,40.296 C35.4259769,42.196 36.0259769,45.896 32.6259769,45.896 C29.2259769,45.896 19.4259769,44.696 17.7259769,39.596 C16.6259769,36.296 15.9259769,29.596 15.6259769,19.296 C15.4259769,19.296 15.2259769,19.296 15.0259769,19.296 C12.1259769,19.296 9.72597686,21.696 9.72597686,24.596 C9.72597686,26.096 10.3259769,27.396 11.3259769,28.396 C10.1259769,30.096 8.72597686,31.896 7.12597686,33.796 C1.32597686,30.396 -3.07402314,19.996 2.72597686,9.996 C4.32597686,5.096 7.92597686,2.496 12.2259769,1.296 C15.6259769,-0.204 19.2259769,-0.304 22.3259769,0.496 Z",
    id: "Hair",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 139.447643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.907273,0 C82.507273,21.7 185.107273,85.7 185.707273,87.5 C186.007273,88.3 175.307273,113.5 153.807273,163.1 L162.807273,166.6 C195.907273,114 211.507273,85 209.807273,79.4 C207.407273,71.4 180.807273,45 130.207273,0.3 L80.907273,0 Z",
    id: "Leg",
    fill: "#D4A181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.107273,151.9 L170.707273,157.2 C201.607273,122.4 213.707273,93.7 211.507273,79 C210.007273,69.2 183.607273,42.9 132.207273,0 L79.907273,0 C81.707273,50.3 176.807273,87.6 178.007273,89.7 C179.307273,91.9 166.707273,112.9 156.107273,151.9 Z",
    id: "Pant",
    fill: "#69A1AC"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.609480, 155.901603)",
    fill: "#E4E4E4",
    id: "Right-Show"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.169048, 17.297591) rotate(20.000000) translate(-27.169048, -17.297591) translate(1.564229, 8.209271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4,5.47664068 C0.5,7.97664068 0,9.87664068 0,11.1766407 C0,12.7766407 0.3,15.0766407 0.8,18.1766407 C2.6,18.1766407 19.2,18.1766407 50.6,18.1766407 C51.9,13.8766407 51.1,11.5766407 48.4,11.2766407 C45.6,10.9766407 43.3,10.6766407 41.5,10.3766407 L18.5,0.076640683 C18,-0.123359317 17.4,0.076640683 17.2,0.576640683 C17.2,0.576640683 17.2,0.576640683 17.2,0.576640683 L15.8,4.07664068 L15.8,4.07664068 C13.2,5.27664068 11.1,5.87664068 9.5,5.87664068 C8.2,5.87664068 6.5,5.37664068 4.3,4.37664068 L4.3,4.37664068 C3.3,3.87664068 2.1,4.37664068 1.7,5.37664068 C1.5,5.47664068 1.4,5.47664068 1.4,5.47664068 Z",
    id: "shoe"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D4A181",
    points: "92.707273 0 47.007273 109.6 2.107273 202.3 12.707273 202.3 128.607273 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left-Shot",
    transform: "translate(0.000000, 192.866551)",
    fill: "#E4E4E4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4,5.47664068 C0.5,7.97664068 0,9.87664068 0,11.1766407 C0,12.7766407 0.3,15.0766407 0.8,18.1766407 C2.6,18.1766407 19.2,18.1766407 50.6,18.1766407 C51.9,13.8766407 51.1,11.5766407 48.4,11.2766407 C45.6,10.9766407 43.3,10.6766407 41.5,10.3766407 L18.5,0.076640683 C18,-0.123359317 17.4,0.076640683 17.2,0.576640683 C17.2,0.576640683 17.2,0.576640683 17.2,0.576640683 L15.8,4.07664068 L15.8,4.07664068 C13.2,5.27664068 11.1,5.87664068 9.5,5.87664068 C8.2,5.87664068 6.5,5.37664068 4.3,4.37664068 L4.3,4.37664068 C3.3,3.87664068 2.1,4.37664068 1.7,5.37664068 C1.4,5.37664068 1.4,5.37664068 1.4,5.47664068 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.107273,183.1 L29.607273,187.5 C47.907273,160.7 124.107273,51.1 132.407273,0 L80.007273,0 C52.107273,36.9 23.507273,155.9 6.107273,183.1 Z",
    id: "Path",
    fill: "#69A1AC"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.424823, 43.737823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2091168,85.1337643 L48.7091168,85.2337643 C37.3091168,121.933764 31.1091168,141.433764 30.2091168,143.733764 C28.2091168,148.833764 32.5091168,156.533764 34.3091168,160.633764 C31.5091168,161.833764 30.2091168,160.433764 28.7091168,158.833764 L28.4091168,158.533764 C26.8091168,156.833764 25.1091168,155.133764 21.3091168,156.933764 C20.2091168,157.433764 19.2091168,157.933764 18.2091168,158.533764 L17.7091168,158.833764 C17.3091168,159.033764 17.0091168,159.233764 16.6091168,159.433764 L16.1091168,159.733764 C11.4091168,162.433764 7.0091168,164.633764 1.1091168,161.033764 C0.109116802,160.433764 -0.990883198,158.133764 1.6091168,156.333764 C8.1091168,151.833764 17.5091168,144.133764 18.7091168,141.533764 C20.5091168,138.033764 24.3091168,119.233764 30.2091168,85.1337643 L30.2091168,85.1337643 Z M138.409117,84.4337643 L166.609117,105.133764 C174.209117,107.233764 180.609117,109.733764 185.709117,112.833764 C186.909117,113.933764 188.409117,116.133764 183.409117,115.833764 L183.109117,115.833764 L183.109117,115.833764 L182.509117,115.833764 C177.809117,115.533764 173.109117,115.433764 172.409117,117.033764 C171.709117,118.733764 174.709117,120.833764 173.309117,123.133764 C172.409117,124.633764 168.009117,120.833764 160.109117,111.533764 L132.209117,99.9337643 L138.409117,84.4337643 Z",
    id: "Skin",
    fill: "#D4A181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7091168,7.73376434 L90.3091168,6.43376434 C118.609117,30.9337643 130.309117,77.9337643 165.009117,102.833764 L156.609117,113.233764 C96.4091168,105.733764 81.5091168,48.3337643 82.7091168,7.73376434 Z",
    id: "Coat-Back",
    fill: "#89C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4091168,103.633764 C80.0091168,103.633764 102.509117,103.633764 117.009117,103.633764 C120.109117,103.633764 119.509117,99.1337643 119.109117,96.9337643 C113.809117,71.0337643 93.7091168,43.0337643 93.7091168,6.13376434 L74.2091168,3.03376434 C58.1091168,28.9337643 52.6091168,60.8337643 49.4091168,103.633764 Z",
    id: "Shirt",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8091168,3.03376434 C73.5091168,3.03376434 74.1091168,3.03376434 74.6091168,3.13376434 L80.7091168,3.43376434 C98.2091168,62.7337643 103.009117,102.333764 95.2091168,122.133764 L95.2091168,122.133764 L42.0091168,122.133764 C38.8091168,129.433764 35.8091168,135.633764 33.0091168,140.633764 L33.0091168,140.633764 L18.5091168,140.633764 C17.1091168,96.6337643 27.6091168,59.2337643 49.9091168,28.5337643 C47.1091168,27.7337643 44.8091168,25.8337643 43.2091168,22.8337643 C36.1091168,10.0337643 38.6091168,2.93376434 46.3091168,0.633764336 C54.0091168,-1.66623566 60.7091168,3.03376434 72.8091168,3.03376434 Z",
    id: "Coat-Front",
    fill: "#C1DEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7091168,122.233764 L42.0091168,122.233764 C45.7091168,113.633764 49.5091168,103.533764 53.6091168,91.7337643 C55.3091168,105.733764 58.0091168,115.833764 61.7091168,122.233764 Z",
    id: "Shade",
    fillOpacity: 0.1,
    fill: "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-602",
    opacity: 0.3459,
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092.000000, 312.000000)",
    id: "Group-601",
    opacity: 0.5159
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,4 C15.1,4 16,3.1 16,2 C16,0.9 15.1,0 14,0 C12.9,0 12,0.9 12,2 C12,3.1 12.9,4 14,4",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,4 C28.1,4 29,3.1 29,2 C29,0.9 28.1,0 27,0 C25.9,0 25,0.9 25,2 C25,3.1 25.9,4 27,4",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,4 C40.1,4 41,3.1 41,2 C41,0.9 40.1,0 39,0 C37.9,0 37,0.9 37,2 C37,3.1 37.9,4 39,4",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,4 C53.1,4 54,3.1 54,2 C54,0.9 53.1,0 52,0 C50.9,0 50,0.9 50,2 C50,3.1 50.9,4 52,4",
    id: "Fill-9",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,4 C66.1,4 67,3.1 67,2 C67,0.9 66.1,0 65,0 C63.9,0 63,0.9 63,2 C63,3.1 63.9,4 65,4",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,4 C78.1,4 79,3.1 79,2 C79,0.9 78.1,0 77,0 C75.9,0 75,0.9 75,2 C75,3.1 75.9,4 77,4",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,4 C91.1,4 92,3.1 92,2 C92,0.9 91.1,0 90,0 C88.9,0 88,0.9 88,2 C88,3.1 88.9,4 90,4",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,4 C103.1,4 104,3.1 104,2 C104,0.9 103.1,0 102,0 C100.9,0 100,0.9 100,2 C100,3.1 100.9,4 102,4",
    id: "Fill-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,4 C116.1,4 117,3.1 117,2 C117,0.9 116.1,0 115,0 C113.9,0 113,0.9 113,2 C113,3.1 113.9,4 115,4",
    id: "Fill-19",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,4 C128.1,4 129,3.1 129,2 C129,0.9 128.1,0 127,0 C125.9,0 125,0.9 125,2 C125,3.1 125.9,4 127,4",
    id: "Fill-21",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,4 C141.1,4 142,3.1 142,2 C142,0.9 141.1,0 140,0 C138.9,0 138,0.9 138,2 C138,3.1 138.9,4 140,4",
    id: "Fill-23",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,4 C153.1,4 154,3.1 154,2 C154,0.9 153.1,0 152,0 C150.9,0 150,0.9 150,2 C150,3.1 150.9,4 152,4",
    id: "Fill-25",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,4 C166.1,4 167,3.1 167,2 C167,0.9 166.1,0 165,0 C163.9,0 163,0.9 163,2 C163,3.1 163.9,4 165,4",
    id: "Fill-27",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,4 C179.1,4 180,3.1 180,2 C180,0.9 179.1,0 178,0 C176.9,0 176,0.9 176,2 C176,3.1 176.9,4 178,4",
    id: "Fill-29",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,4 C191.1,4 192,3.1 192,2 C192,0.9 191.1,0 190,0 C188.9,0 188,0.9 188,2 C188,3.1 188.9,4 190,4",
    id: "Fill-31",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,4 C204.1,4 205,3.1 205,2 C205,0.9 204.1,0 203,0 C201.9,0 201,0.9 201,2 C201,3.1 201.9,4 203,4",
    id: "Fill-33",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,4 C216.1,4 217,3.1 217,2 C217,0.9 216.1,0 215,0 C213.9,0 213,0.9 213,2 C213,3.1 213.9,4 215,4",
    id: "Fill-35",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,4 C229.1,4 230,3.1 230,2 C230,0.9 229.1,0 228,0 C226.9,0 226,0.9 226,2 C226,3.1 226.9,4 228,4",
    id: "Fill-37",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,4 C241.1,4 242,3.1 242,2 C242,0.9 241.1,0 240,0 C238.9,0 238,0.9 238,2 C238,3.1 238.9,4 240,4",
    id: "Fill-39",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,4 C254.1,4 255,3.1 255,2 C255,0.9 254.1,0 253,0 C251.9,0 251,0.9 251,2 C251,3.1 251.9,4 253,4",
    id: "Fill-41",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,4 C266.1,4 267,3.1 267,2 C267,0.9 266.1,0 265,0 C263.9,0 263,0.9 263,2 C263,3.1 263.9,4 265,4",
    id: "Fill-43",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,4 C279.1,4 280,3.1 280,2 C280,0.9 279.1,0 278,0 C276.9,0 276,0.9 276,2 C276,3.1 276.9,4 278,4",
    id: "Fill-45",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,4 C292.1,4 293,3.1 293,2 C293,0.9 292.1,0 291,0 C289.9,0 289,0.9 289,2 C289,3.1 289.9,4 291,4",
    id: "Fill-47",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,4 C304.1,4 305,3.1 305,2 C305,0.9 304.1,0 303,0 C301.9,0 301,0.9 301,2 C301,3.1 301.9,4 303,4",
    id: "Fill-49",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,4 C317.1,4 318,3.1 318,2 C318,0.9 317.1,0 316,0 C314.9,0 314,0.9 314,2 C314,3.1 314.9,4 316,4",
    id: "Fill-51",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,4 C329.1,4 330,3.1 330,2 C330,0.9 329.1,0 328,0 C326.9,0 326,0.9 326,2 C326,3.1 326.9,4 328,4",
    id: "Fill-53",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,4 C342.1,4 343,3.1 343,2 C343,0.9 342.1,0 341,0 C339.9,0 339,0.9 339,2 C339,3.1 339.9,4 341,4",
    id: "Fill-55",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,16 C3.1,16 4,15.1 4,14 C4,12.9 3.1,12 2,12 C0.9,12 0,12.9 0,14 C0,15.1 0.9,16 2,16",
    id: "Fill-81",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,16 C15.1,16 16,15.1 16,14 C16,12.9 15.1,12 14,12 C12.9,12 12,12.9 12,14 C12,15.1 12.9,16 14,16",
    id: "Fill-83",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,16 C28.1,16 29,15.1 29,14 C29,12.9 28.1,12 27,12 C25.9,12 25,12.9 25,14 C25,15.1 25.9,16 27,16",
    id: "Fill-85",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,16 C40.1,16 41,15.1 41,14 C41,12.9 40.1,12 39,12 C37.9,12 37,12.9 37,14 C37,15.1 37.9,16 39,16",
    id: "Fill-87",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,16 C53.1,16 54,15.1 54,14 C54,12.9 53.1,12 52,12 C50.9,12 50,12.9 50,14 C50,15.1 50.9,16 52,16",
    id: "Fill-89",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,16 C66.1,16 67,15.1 67,14 C67,12.9 66.1,12 65,12 C63.9,12 63,12.9 63,14 C63,15.1 63.9,16 65,16",
    id: "Fill-91",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,16 C78.1,16 79,15.1 79,14 C79,12.9 78.1,12 77,12 C75.9,12 75,12.9 75,14 C75,15.1 75.9,16 77,16",
    id: "Fill-93",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,16 C91.1,16 92,15.1 92,14 C92,12.9 91.1,12 90,12 C88.9,12 88,12.9 88,14 C88,15.1 88.9,16 90,16",
    id: "Fill-95",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,16 C103.1,16 104,15.1 104,14 C104,12.9 103.1,12 102,12 C100.9,12 100,12.9 100,14 C100,15.1 100.9,16 102,16",
    id: "Fill-97",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,16 C116.1,16 117,15.1 117,14 C117,12.9 116.1,12 115,12 C113.9,12 113,12.9 113,14 C113,15.1 113.9,16 115,16",
    id: "Fill-99",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,16 C128.1,16 129,15.1 129,14 C129,12.9 128.1,12 127,12 C125.9,12 125,12.9 125,14 C125,15.1 125.9,16 127,16",
    id: "Fill-101",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,16 C141.1,16 142,15.1 142,14 C142,12.9 141.1,12 140,12 C138.9,12 138,12.9 138,14 C138,15.1 138.9,16 140,16",
    id: "Fill-103",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,16 C153.1,16 154,15.1 154,14 C154,12.9 153.1,12 152,12 C150.9,12 150,12.9 150,14 C150,15.1 150.9,16 152,16",
    id: "Fill-105",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,16 C166.1,16 167,15.1 167,14 C167,12.9 166.1,12 165,12 C163.9,12 163,12.9 163,14 C163,15.1 163.9,16 165,16",
    id: "Fill-107",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,16 C179.1,16 180,15.1 180,14 C180,12.9 179.1,12 178,12 C176.9,12 176,12.9 176,14 C176,15.1 176.9,16 178,16",
    id: "Fill-109",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,16 C191.1,16 192,15.1 192,14 C192,12.9 191.1,12 190,12 C188.9,12 188,12.9 188,14 C188,15.1 188.9,16 190,16",
    id: "Fill-111",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,16 C204.1,16 205,15.1 205,14 C205,12.9 204.1,12 203,12 C201.9,12 201,12.9 201,14 C201,15.1 201.9,16 203,16",
    id: "Fill-113",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,16 C216.1,16 217,15.1 217,14 C217,12.9 216.1,12 215,12 C213.9,12 213,12.9 213,14 C213,15.1 213.9,16 215,16",
    id: "Fill-115",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,16 C229.1,16 230,15.1 230,14 C230,12.9 229.1,12 228,12 C226.9,12 226,12.9 226,14 C226,15.1 226.9,16 228,16",
    id: "Fill-117",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,16 C241.1,16 242,15.1 242,14 C242,12.9 241.1,12 240,12 C238.9,12 238,12.9 238,14 C238,15.1 238.9,16 240,16",
    id: "Fill-119",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,16 C254.1,16 255,15.1 255,14 C255,12.9 254.1,12 253,12 C251.9,12 251,12.9 251,14 C251,15.1 251.9,16 253,16",
    id: "Fill-121",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,16 C266.1,16 267,15.1 267,14 C267,12.9 266.1,12 265,12 C263.9,12 263,12.9 263,14 C263,15.1 263.9,16 265,16",
    id: "Fill-123",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,16 C279.1,16 280,15.1 280,14 C280,12.9 279.1,12 278,12 C276.9,12 276,12.9 276,14 C276,15.1 276.9,16 278,16",
    id: "Fill-125",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,16 C292.1,16 293,15.1 293,14 C293,12.9 292.1,12 291,12 C289.9,12 289,12.9 289,14 C289,15.1 289.9,16 291,16",
    id: "Fill-127",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,16 C304.1,16 305,15.1 305,14 C305,12.9 304.1,12 303,12 C301.9,12 301,12.9 301,14 C301,15.1 301.9,16 303,16",
    id: "Fill-129",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,16 C317.1,16 318,15.1 318,14 C318,12.9 317.1,12 316,12 C314.9,12 314,12.9 314,14 C314,15.1 314.9,16 316,16",
    id: "Fill-131",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,16 C329.1,16 330,15.1 330,14 C330,12.9 329.1,12 328,12 C326.9,12 326,12.9 326,14 C326,15.1 326.9,16 328,16",
    id: "Fill-133",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,16 C342.1,16 343,15.1 343,14 C343,12.9 342.1,12 341,12 C339.9,12 339,12.9 339,14 C339,15.1 339.9,16 341,16",
    id: "Fill-135",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,29 C3.1,29 4,28.1 4,27 C4,25.9 3.1,25 2,25 C0.9,25 0,25.9 0,27 C0,28.1 0.9,29 2,29",
    id: "Fill-161",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,29 C15.1,29 16,28.1 16,27 C16,25.9 15.1,25 14,25 C12.9,25 12,25.9 12,27 C12,28.1 12.9,29 14,29",
    id: "Fill-163",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,29 C28.1,29 29,28.1 29,27 C29,25.9 28.1,25 27,25 C25.9,25 25,25.9 25,27 C25,28.1 25.9,29 27,29",
    id: "Fill-165",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,29 C40.1,29 41,28.1 41,27 C41,25.9 40.1,25 39,25 C37.9,25 37,25.9 37,27 C37,28.1 37.9,29 39,29",
    id: "Fill-167",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,29 C53.1,29 54,28.1 54,27 C54,25.9 53.1,25 52,25 C50.9,25 50,25.9 50,27 C50,28.1 50.9,29 52,29",
    id: "Fill-169",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,29 C66.1,29 67,28.1 67,27 C67,25.9 66.1,25 65,25 C63.9,25 63,25.9 63,27 C63,28.1 63.9,29 65,29",
    id: "Fill-171",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,29 C78.1,29 79,28.1 79,27 C79,25.9 78.1,25 77,25 C75.9,25 75,25.9 75,27 C75,28.1 75.9,29 77,29",
    id: "Fill-173",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,29 C91.1,29 92,28.1 92,27 C92,25.9 91.1,25 90,25 C88.9,25 88,25.9 88,27 C88,28.1 88.9,29 90,29",
    id: "Fill-175",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,29 C103.1,29 104,28.1 104,27 C104,25.9 103.1,25 102,25 C100.9,25 100,25.9 100,27 C100,28.1 100.9,29 102,29",
    id: "Fill-177",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,29 C116.1,29 117,28.1 117,27 C117,25.9 116.1,25 115,25 C113.9,25 113,25.9 113,27 C113,28.1 113.9,29 115,29",
    id: "Fill-179",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,29 C128.1,29 129,28.1 129,27 C129,25.9 128.1,25 127,25 C125.9,25 125,25.9 125,27 C125,28.1 125.9,29 127,29",
    id: "Fill-181",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,29 C141.1,29 142,28.1 142,27 C142,25.9 141.1,25 140,25 C138.9,25 138,25.9 138,27 C138,28.1 138.9,29 140,29",
    id: "Fill-183",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,29 C153.1,29 154,28.1 154,27 C154,25.9 153.1,25 152,25 C150.9,25 150,25.9 150,27 C150,28.1 150.9,29 152,29",
    id: "Fill-185",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,29 C166.1,29 167,28.1 167,27 C167,25.9 166.1,25 165,25 C163.9,25 163,25.9 163,27 C163,28.1 163.9,29 165,29",
    id: "Fill-187",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,29 C179.1,29 180,28.1 180,27 C180,25.9 179.1,25 178,25 C176.9,25 176,25.9 176,27 C176,28.1 176.9,29 178,29",
    id: "Fill-189",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,29 C191.1,29 192,28.1 192,27 C192,25.9 191.1,25 190,25 C188.9,25 188,25.9 188,27 C188,28.1 188.9,29 190,29",
    id: "Fill-191",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,29 C204.1,29 205,28.1 205,27 C205,25.9 204.1,25 203,25 C201.9,25 201,25.9 201,27 C201,28.1 201.9,29 203,29",
    id: "Fill-193",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,29 C216.1,29 217,28.1 217,27 C217,25.9 216.1,25 215,25 C213.9,25 213,25.9 213,27 C213,28.1 213.9,29 215,29",
    id: "Fill-195",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,29 C229.1,29 230,28.1 230,27 C230,25.9 229.1,25 228,25 C226.9,25 226,25.9 226,27 C226,28.1 226.9,29 228,29",
    id: "Fill-197",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,29 C241.1,29 242,28.1 242,27 C242,25.9 241.1,25 240,25 C238.9,25 238,25.9 238,27 C238,28.1 238.9,29 240,29",
    id: "Fill-199",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,29 C254.1,29 255,28.1 255,27 C255,25.9 254.1,25 253,25 C251.9,25 251,25.9 251,27 C251,28.1 251.9,29 253,29",
    id: "Fill-201",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,29 C266.1,29 267,28.1 267,27 C267,25.9 266.1,25 265,25 C263.9,25 263,25.9 263,27 C263,28.1 263.9,29 265,29",
    id: "Fill-203",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,29 C279.1,29 280,28.1 280,27 C280,25.9 279.1,25 278,25 C276.9,25 276,25.9 276,27 C276,28.1 276.9,29 278,29",
    id: "Fill-205",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,29 C292.1,29 293,28.1 293,27 C293,25.9 292.1,25 291,25 C289.9,25 289,25.9 289,27 C289,28.1 289.9,29 291,29",
    id: "Fill-207",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,29 C304.1,29 305,28.1 305,27 C305,25.9 304.1,25 303,25 C301.9,25 301,25.9 301,27 C301,28.1 301.9,29 303,29",
    id: "Fill-209",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,29 C317.1,29 318,28.1 318,27 C318,25.9 317.1,25 316,25 C314.9,25 314,25.9 314,27 C314,28.1 314.9,29 316,29",
    id: "Fill-211",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,29 C329.1,29 330,28.1 330,27 C330,25.9 329.1,25 328,25 C326.9,25 326,25.9 326,27 C326,28.1 326.9,29 328,29",
    id: "Fill-213",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,29 C342.1,29 343,28.1 343,27 C343,25.9 342.1,25 341,25 C339.9,25 339,25.9 339,27 C339,28.1 339.9,29 341,29",
    id: "Fill-215",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,42 C3.1,42 4,41.1 4,40 C4,38.9 3.1,38 2,38 C0.9,38 0,38.9 0,40 C0,41.1 0.9,42 2,42",
    id: "Fill-241",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,42 C15.1,42 16,41.1 16,40 C16,38.9 15.1,38 14,38 C12.9,38 12,38.9 12,40 C12,41.1 12.9,42 14,42",
    id: "Fill-243",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,42 C28.1,42 29,41.1 29,40 C29,38.9 28.1,38 27,38 C25.9,38 25,38.9 25,40 C25,41.1 25.9,42 27,42",
    id: "Fill-245",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,42 C40.1,42 41,41.1 41,40 C41,38.9 40.1,38 39,38 C37.9,38 37,38.9 37,40 C37,41.1 37.9,42 39,42",
    id: "Fill-247",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,42 C53.1,42 54,41.1 54,40 C54,38.9 53.1,38 52,38 C50.9,38 50,38.9 50,40 C50,41.1 50.9,42 52,42",
    id: "Fill-249",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,42 C66.1,42 67,41.1 67,40 C67,38.9 66.1,38 65,38 C63.9,38 63,38.9 63,40 C63,41.1 63.9,42 65,42",
    id: "Fill-251",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,42 C78.1,42 79,41.1 79,40 C79,38.9 78.1,38 77,38 C75.9,38 75,38.9 75,40 C75,41.1 75.9,42 77,42",
    id: "Fill-253",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,42 C91.1,42 92,41.1 92,40 C92,38.9 91.1,38 90,38 C88.9,38 88,38.9 88,40 C88,41.1 88.9,42 90,42",
    id: "Fill-255",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,42 C103.1,42 104,41.1 104,40 C104,38.9 103.1,38 102,38 C100.9,38 100,38.9 100,40 C100,41.1 100.9,42 102,42",
    id: "Fill-257",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,42 C116.1,42 117,41.1 117,40 C117,38.9 116.1,38 115,38 C113.9,38 113,38.9 113,40 C113,41.1 113.9,42 115,42",
    id: "Fill-259",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,42 C128.1,42 129,41.1 129,40 C129,38.9 128.1,38 127,38 C125.9,38 125,38.9 125,40 C125,41.1 125.9,42 127,42",
    id: "Fill-261",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,42 C141.1,42 142,41.1 142,40 C142,38.9 141.1,38 140,38 C138.9,38 138,38.9 138,40 C138,41.1 138.9,42 140,42",
    id: "Fill-263",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,42 C153.1,42 154,41.1 154,40 C154,38.9 153.1,38 152,38 C150.9,38 150,38.9 150,40 C150,41.1 150.9,42 152,42",
    id: "Fill-265",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,42 C166.1,42 167,41.1 167,40 C167,38.9 166.1,38 165,38 C163.9,38 163,38.9 163,40 C163,41.1 163.9,42 165,42",
    id: "Fill-267",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,42 C179.1,42 180,41.1 180,40 C180,38.9 179.1,38 178,38 C176.9,38 176,38.9 176,40 C176,41.1 176.9,42 178,42",
    id: "Fill-269",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,42 C191.1,42 192,41.1 192,40 C192,38.9 191.1,38 190,38 C188.9,38 188,38.9 188,40 C188,41.1 188.9,42 190,42",
    id: "Fill-271",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,42 C204.1,42 205,41.1 205,40 C205,38.9 204.1,38 203,38 C201.9,38 201,38.9 201,40 C201,41.1 201.9,42 203,42",
    id: "Fill-273",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,42 C216.1,42 217,41.1 217,40 C217,38.9 216.1,38 215,38 C213.9,38 213,38.9 213,40 C213,41.1 213.9,42 215,42",
    id: "Fill-275",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,42 C229.1,42 230,41.1 230,40 C230,38.9 229.1,38 228,38 C226.9,38 226,38.9 226,40 C226,41.1 226.9,42 228,42",
    id: "Fill-277",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,42 C241.1,42 242,41.1 242,40 C242,38.9 241.1,38 240,38 C238.9,38 238,38.9 238,40 C238,41.1 238.9,42 240,42",
    id: "Fill-279",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,42 C254.1,42 255,41.1 255,40 C255,38.9 254.1,38 253,38 C251.9,38 251,38.9 251,40 C251,41.1 251.9,42 253,42",
    id: "Fill-281",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,42 C266.1,42 267,41.1 267,40 C267,38.9 266.1,38 265,38 C263.9,38 263,38.9 263,40 C263,41.1 263.9,42 265,42",
    id: "Fill-283",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,42 C279.1,42 280,41.1 280,40 C280,38.9 279.1,38 278,38 C276.9,38 276,38.9 276,40 C276,41.1 276.9,42 278,42",
    id: "Fill-285",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,42 C292.1,42 293,41.1 293,40 C293,38.9 292.1,38 291,38 C289.9,38 289,38.9 289,40 C289,41.1 289.9,42 291,42",
    id: "Fill-287",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,42 C304.1,42 305,41.1 305,40 C305,38.9 304.1,38 303,38 C301.9,38 301,38.9 301,40 C301,41.1 301.9,42 303,42",
    id: "Fill-289",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,42 C317.1,42 318,41.1 318,40 C318,38.9 317.1,38 316,38 C314.9,38 314,38.9 314,40 C314,41.1 314.9,42 316,42",
    id: "Fill-291",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,42 C329.1,42 330,41.1 330,40 C330,38.9 329.1,38 328,38 C326.9,38 326,38.9 326,40 C326,41.1 326.9,42 328,42",
    id: "Fill-293",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,42 C342.1,42 343,41.1 343,40 C343,38.9 342.1,38 341,38 C339.9,38 339,38.9 339,40 C339,41.1 339.9,42 341,42",
    id: "Fill-295",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,54 C3.1,54 4,53.1 4,52 C4,50.9 3.1,50 2,50 C0.9,50 0,50.9 0,52 C0,53.1 0.9,54 2,54",
    id: "Fill-321",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,54 C15.1,54 16,53.1 16,52 C16,50.9 15.1,50 14,50 C12.9,50 12,50.9 12,52 C12,53.1 12.9,54 14,54",
    id: "Fill-323",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,54 C28.1,54 29,53.1 29,52 C29,50.9 28.1,50 27,50 C25.9,50 25,50.9 25,52 C25,53.1 25.9,54 27,54",
    id: "Fill-325",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,54 C40.1,54 41,53.1 41,52 C41,50.9 40.1,50 39,50 C37.9,50 37,50.9 37,52 C37,53.1 37.9,54 39,54",
    id: "Fill-327",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,54 C53.1,54 54,53.1 54,52 C54,50.9 53.1,50 52,50 C50.9,50 50,50.9 50,52 C50,53.1 50.9,54 52,54",
    id: "Fill-329",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,54 C66.1,54 67,53.1 67,52 C67,50.9 66.1,50 65,50 C63.9,50 63,50.9 63,52 C63,53.1 63.9,54 65,54",
    id: "Fill-331",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,54 C78.1,54 79,53.1 79,52 C79,50.9 78.1,50 77,50 C75.9,50 75,50.9 75,52 C75,53.1 75.9,54 77,54",
    id: "Fill-333",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,54 C91.1,54 92,53.1 92,52 C92,50.9 91.1,50 90,50 C88.9,50 88,50.9 88,52 C88,53.1 88.9,54 90,54",
    id: "Fill-335",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,54 C103.1,54 104,53.1 104,52 C104,50.9 103.1,50 102,50 C100.9,50 100,50.9 100,52 C100,53.1 100.9,54 102,54",
    id: "Fill-337",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,54 C116.1,54 117,53.1 117,52 C117,50.9 116.1,50 115,50 C113.9,50 113,50.9 113,52 C113,53.1 113.9,54 115,54",
    id: "Fill-339",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,54 C128.1,54 129,53.1 129,52 C129,50.9 128.1,50 127,50 C125.9,50 125,50.9 125,52 C125,53.1 125.9,54 127,54",
    id: "Fill-341",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,54 C141.1,54 142,53.1 142,52 C142,50.9 141.1,50 140,50 C138.9,50 138,50.9 138,52 C138,53.1 138.9,54 140,54",
    id: "Fill-343",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,54 C153.1,54 154,53.1 154,52 C154,50.9 153.1,50 152,50 C150.9,50 150,50.9 150,52 C150,53.1 150.9,54 152,54",
    id: "Fill-345",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,54 C166.1,54 167,53.1 167,52 C167,50.9 166.1,50 165,50 C163.9,50 163,50.9 163,52 C163,53.1 163.9,54 165,54",
    id: "Fill-347",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,54 C179.1,54 180,53.1 180,52 C180,50.9 179.1,50 178,50 C176.9,50 176,50.9 176,52 C176,53.1 176.9,54 178,54",
    id: "Fill-349",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,54 C191.1,54 192,53.1 192,52 C192,50.9 191.1,50 190,50 C188.9,50 188,50.9 188,52 C188,53.1 188.9,54 190,54",
    id: "Fill-351",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,54 C204.1,54 205,53.1 205,52 C205,50.9 204.1,50 203,50 C201.9,50 201,50.9 201,52 C201,53.1 201.9,54 203,54",
    id: "Fill-353",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,54 C216.1,54 217,53.1 217,52 C217,50.9 216.1,50 215,50 C213.9,50 213,50.9 213,52 C213,53.1 213.9,54 215,54",
    id: "Fill-355",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,54 C229.1,54 230,53.1 230,52 C230,50.9 229.1,50 228,50 C226.9,50 226,50.9 226,52 C226,53.1 226.9,54 228,54",
    id: "Fill-357",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,54 C241.1,54 242,53.1 242,52 C242,50.9 241.1,50 240,50 C238.9,50 238,50.9 238,52 C238,53.1 238.9,54 240,54",
    id: "Fill-359",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,54 C254.1,54 255,53.1 255,52 C255,50.9 254.1,50 253,50 C251.9,50 251,50.9 251,52 C251,53.1 251.9,54 253,54",
    id: "Fill-361",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,54 C266.1,54 267,53.1 267,52 C267,50.9 266.1,50 265,50 C263.9,50 263,50.9 263,52 C263,53.1 263.9,54 265,54",
    id: "Fill-363",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,54 C279.1,54 280,53.1 280,52 C280,50.9 279.1,50 278,50 C276.9,50 276,50.9 276,52 C276,53.1 276.9,54 278,54",
    id: "Fill-365",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,54 C292.1,54 293,53.1 293,52 C293,50.9 292.1,50 291,50 C289.9,50 289,50.9 289,52 C289,53.1 289.9,54 291,54",
    id: "Fill-367",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,54 C304.1,54 305,53.1 305,52 C305,50.9 304.1,50 303,50 C301.9,50 301,50.9 301,52 C301,53.1 301.9,54 303,54",
    id: "Fill-369",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,54 C317.1,54 318,53.1 318,52 C318,50.9 317.1,50 316,50 C314.9,50 314,50.9 314,52 C314,53.1 314.9,54 316,54",
    id: "Fill-371",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,54 C329.1,54 330,53.1 330,52 C330,50.9 329.1,50 328,50 C326.9,50 326,50.9 326,52 C326,53.1 326.9,54 328,54",
    id: "Fill-373",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,54 C342.1,54 343,53.1 343,52 C343,50.9 342.1,50 341,50 C339.9,50 339,50.9 339,52 C339,53.1 339.9,54 341,54",
    id: "Fill-375",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,67 C3.1,67 4,66.1 4,65 C4,63.9 3.1,63 2,63 C0.9,63 0,63.9 0,65 C0,66.1 0.9,67 2,67",
    id: "Fill-401",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,67 C15.1,67 16,66.1 16,65 C16,63.9 15.1,63 14,63 C12.9,63 12,63.9 12,65 C12,66.1 12.9,67 14,67",
    id: "Fill-403",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,67 C28.1,67 29,66.1 29,65 C29,63.9 28.1,63 27,63 C25.9,63 25,63.9 25,65 C25,66.1 25.9,67 27,67",
    id: "Fill-405",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,67 C40.1,67 41,66.1 41,65 C41,63.9 40.1,63 39,63 C37.9,63 37,63.9 37,65 C37,66.1 37.9,67 39,67",
    id: "Fill-407",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,67 C53.1,67 54,66.1 54,65 C54,63.9 53.1,63 52,63 C50.9,63 50,63.9 50,65 C50,66.1 50.9,67 52,67",
    id: "Fill-409",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,67 C66.1,67 67,66.1 67,65 C67,63.9 66.1,63 65,63 C63.9,63 63,63.9 63,65 C63,66.1 63.9,67 65,67",
    id: "Fill-411",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,67 C78.1,67 79,66.1 79,65 C79,63.9 78.1,63 77,63 C75.9,63 75,63.9 75,65 C75,66.1 75.9,67 77,67",
    id: "Fill-413",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,67 C91.1,67 92,66.1 92,65 C92,63.9 91.1,63 90,63 C88.9,63 88,63.9 88,65 C88,66.1 88.9,67 90,67",
    id: "Fill-415",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,67 C103.1,67 104,66.1 104,65 C104,63.9 103.1,63 102,63 C100.9,63 100,63.9 100,65 C100,66.1 100.9,67 102,67",
    id: "Fill-417",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,67 C116.1,67 117,66.1 117,65 C117,63.9 116.1,63 115,63 C113.9,63 113,63.9 113,65 C113,66.1 113.9,67 115,67",
    id: "Fill-419",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,67 C128.1,67 129,66.1 129,65 C129,63.9 128.1,63 127,63 C125.9,63 125,63.9 125,65 C125,66.1 125.9,67 127,67",
    id: "Fill-421",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,67 C141.1,67 142,66.1 142,65 C142,63.9 141.1,63 140,63 C138.9,63 138,63.9 138,65 C138,66.1 138.9,67 140,67",
    id: "Fill-423",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,67 C153.1,67 154,66.1 154,65 C154,63.9 153.1,63 152,63 C150.9,63 150,63.9 150,65 C150,66.1 150.9,67 152,67",
    id: "Fill-425",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,67 C166.1,67 167,66.1 167,65 C167,63.9 166.1,63 165,63 C163.9,63 163,63.9 163,65 C163,66.1 163.9,67 165,67",
    id: "Fill-427",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,67 C179.1,67 180,66.1 180,65 C180,63.9 179.1,63 178,63 C176.9,63 176,63.9 176,65 C176,66.1 176.9,67 178,67",
    id: "Fill-429",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,67 C191.1,67 192,66.1 192,65 C192,63.9 191.1,63 190,63 C188.9,63 188,63.9 188,65 C188,66.1 188.9,67 190,67",
    id: "Fill-431",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,67 C204.1,67 205,66.1 205,65 C205,63.9 204.1,63 203,63 C201.9,63 201,63.9 201,65 C201,66.1 201.9,67 203,67",
    id: "Fill-433",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,67 C216.1,67 217,66.1 217,65 C217,63.9 216.1,63 215,63 C213.9,63 213,63.9 213,65 C213,66.1 213.9,67 215,67",
    id: "Fill-435",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,67 C229.1,67 230,66.1 230,65 C230,63.9 229.1,63 228,63 C226.9,63 226,63.9 226,65 C226,66.1 226.9,67 228,67",
    id: "Fill-437",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,67 C241.1,67 242,66.1 242,65 C242,63.9 241.1,63 240,63 C238.9,63 238,63.9 238,65 C238,66.1 238.9,67 240,67",
    id: "Fill-439",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,67 C254.1,67 255,66.1 255,65 C255,63.9 254.1,63 253,63 C251.9,63 251,63.9 251,65 C251,66.1 251.9,67 253,67",
    id: "Fill-441",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,67 C266.1,67 267,66.1 267,65 C267,63.9 266.1,63 265,63 C263.9,63 263,63.9 263,65 C263,66.1 263.9,67 265,67",
    id: "Fill-443",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,67 C279.1,67 280,66.1 280,65 C280,63.9 279.1,63 278,63 C276.9,63 276,63.9 276,65 C276,66.1 276.9,67 278,67",
    id: "Fill-445",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,67 C292.1,67 293,66.1 293,65 C293,63.9 292.1,63 291,63 C289.9,63 289,63.9 289,65 C289,66.1 289.9,67 291,67",
    id: "Fill-447",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,67 C304.1,67 305,66.1 305,65 C305,63.9 304.1,63 303,63 C301.9,63 301,63.9 301,65 C301,66.1 301.9,67 303,67",
    id: "Fill-449",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,67 C317.1,67 318,66.1 318,65 C318,63.9 317.1,63 316,63 C314.9,63 314,63.9 314,65 C314,66.1 314.9,67 316,67",
    id: "Fill-451",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,67 C329.1,67 330,66.1 330,65 C330,63.9 329.1,63 328,63 C326.9,63 326,63.9 326,65 C326,66.1 326.9,67 328,67",
    id: "Fill-453",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,67 C342.1,67 343,66.1 343,65 C343,63.9 342.1,63 341,63 C339.9,63 339,63.9 339,65 C339,66.1 339.9,67 341,67",
    id: "Fill-455",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-483",
    transform: "translate(0.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-481"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-486",
    transform: "translate(12.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-484"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-489",
    transform: "translate(25.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-487"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-492",
    transform: "translate(37.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-490"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-495",
    transform: "translate(50.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-493"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-498",
    transform: "translate(63.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-501",
    transform: "translate(75.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-499"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-504",
    transform: "translate(88.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-502"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-507",
    transform: "translate(100.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-505"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-510",
    transform: "translate(113.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-508"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-513",
    transform: "translate(125.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-511"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-516",
    transform: "translate(138.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-514"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-519",
    transform: "translate(150.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-517"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-522",
    transform: "translate(163.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-520"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-525",
    transform: "translate(176.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-523"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-528",
    transform: "translate(188.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-526"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-531",
    transform: "translate(201.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-529"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-534",
    transform: "translate(213.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-532"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-537",
    transform: "translate(226.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-535"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-540",
    transform: "translate(238.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-538"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-543",
    transform: "translate(251.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-541"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-546",
    transform: "translate(263.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-544"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-549",
    transform: "translate(276.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-547"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-552",
    transform: "translate(289.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-550"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-555",
    transform: "translate(301.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-553"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-558",
    transform: "translate(314.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-556"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-561",
    transform: "translate(326.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-559"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-564",
    transform: "translate(339.000000, 75.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4",
    id: "Fill-562"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTspayBannerLandingOmino);
export default __webpack_public_path__ + "static/media/tspay_banner_landing-omino.d393bb125012b4abde3cf4c1141d19e0.svg";
export { ForwardRef as ReactComponent };